import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Nav from "../../../navbar";

function Buyleads() {
  const navigate = useNavigate();

  const [uid, setUid] = useState("");
  const [lead, setLead] = useState([]);
  const [darw, setDarw] = useState(true);

  useEffect(() => {
    const v = JSON.parse(localStorage.getItem("USER"));
    if (v !== null) {
      setUid(v[0].id);
      lead_view_all(v[0].id);
    }
  }, []);

  // Function to fix invalid JSON strings
  const fixInvalidJson = (jsonString) => {
    try {
      if (!jsonString || typeof jsonString !== "string") return [];
  
      // Fix unescaped double quotes inside values, but only when necessary
      jsonString = jsonString.replace(/(\d+\.\d*)\"/g, '$1\\"'); 
  
      // Ensure proper JSON format before parsing
      jsonString = jsonString
        .replace(/,\s*}/g, "}")  // Remove trailing commas before closing braces
        .replace(/,\s*]/g, "]")  // Remove trailing commas before closing brackets
        .trim();                 // Remove unnecessary spaces
  
      return JSON.parse(jsonString); // Parse fixed JSON string
    } catch (error) {
      console.error("JSON Fixing Error:", error.message, "Original JSON:", jsonString);
      return []; // Return an empty array as a fallback
    }
  };

  const lead_view_all = async (id) => {
    const data = new FormData();
    data.append("uid", id);

    axios({
      method: "post",
      url: "/pro/view_product_user.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        console.log("view_product_user", s.data);
        setLead(s.data);
      })
      .catch((s) => {
        console.log("here catch =>>", s);
      });
  };

  return (
    <div>
      <Nav setDarw={setDarw} darw={darw} />
      <div
        style={{ overflow: "auto", display: "flex", flexDirection: "column", padding: "0px" }}
        className={
          darw
            ? ["header-protected-screen padding-dashboard-table", "mobile-table padding-dashboard-table"].join(" ")
            : ["header-protected-screen-full-width padding-dashboard-table", "mobile-table padding-dashboard-table"].join(" ")
        }
      >
        <div className="container-fluid  pb-4">
          <div className="row my-2">
              <h3 className="main-heading-style">
                Product Direct Requests
              </h3>
          </div>
            <section id="main-content">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {lead.length === 0 ? (
                        <></>
                      ) : (
                        <>
                          {lead.map((z, yyi) => (
                            <>
                              {z.child.length > 0 && (
                                <>
                                  <h4 className="mt-5">Product: {z.title}</h4>
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Quantity</th>
                                        <th>Unit</th>
                                        <th>Price</th>
                                        <th>Description</th>
                                        <th>Time</th>
                                        <th>File</th>
                                        <th>Status</th>
                                        <th>Controls</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {z.child.map((v, ii) => {
                                        const sheetData = fixInvalidJson(v.sheet);

                                        return (
                                          <tr key={ii}>
                                            <td>{v.pid}</td>
                                            <td>{sheetData.length > 0 ? sheetData[0].name : "N/A"}</td>
                                            <td>{sheetData.length > 0 ? sheetData[0].qty : "N/A"}</td>
                                            <td>{sheetData.length > 0 ? sheetData[0].price : "N/A"}</td>
                                            <td>{sheetData.length > 0 ? sheetData[0].piece : "N/A"}</td>
                                            <td>{sheetData.length > 0 ? sheetData[0].des : "N/A"}</td>
                                            <td>{v.time}</td>
                                            <td>
                                              <a href={v.file} target="_blank" download={v.lead_id}>
                                                Download
                                              </a>
                                            </td>
                                            <td>Active</td>
                                            <td>
                                              <button
                                                style={{ borderRadius: "14px" }}
                                                className="btn-primary"
                                                onClick={() => navigate("/chat?cid=" + v.uid)}
                                              >
                                                Contact Buyer
                                              </button>
                                            </td>

                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </>
                              )}
                            </>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
  );
}

export default Buyleads;
